import React, { useEffect, useMemo } from 'react';
import { useState } from 'react';
import { noop } from '@src/utils/common-util';

class YtVideoDepend {
  load = false;
  Player = null;
  resolve = noop;
  constructor() {
    // https://developers.google.com/youtube/iframe_api_reference?hl=zh-cn
    // https://developers.google.com/youtube/player_parameters.html?playerVersion=HTML5&hl=zh-cn
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    window.onYouTubeIframeAPIReady = this.onYouTubeIframeAPIReady.bind(this);
  }

  /**
   * @type YtVideoDepend
   */
  static instance;
  static getInstance() {
    if (!YtVideoDepend.instance) {
      YtVideoDepend.instance = new YtVideoDepend();
    }
    return YtVideoDepend.instance;
  }

  init() {
    if (!this.load) {
      return new Promise(resolve => {
        this.resolve = resolve;
      });
    }
    return this.Player;
  }

  onYouTubeIframeAPIReady() {
    this.load = true;
    this.Player = window.YT;
    this.resolve(this.Player);
  }
}

const YtVideo = ({
  videoId,
  width = '100%',
  height = '100%',
  onPlayerReady = event => {
    event.target.playVideo();
  },
  onStateChange = () => {}
}) => {
  const [timestamp] = useState(new Date().getTime());
  const [divId, setDivId] = useState(`video-${videoId}-${timestamp}`);
  const instance = useMemo(() => YtVideoDepend.getInstance(), []);
  console.log('instance: ', instance);
  useEffect(() => {
    const init = async () => {
      const Player = await instance.init();
      new Player.Player(divId, {
        height,
        width,
        videoId,
        playerVars: {
          modestbranding: 1,
          autoplay: 1,
          iv_load_policy: 3,
          rel: 0,
          playsinline: 1,
          controls: 1
        },
        events: {
          onReady: onPlayerReady,
          onStateChange: onStateChange
        }
      });
    };
    init().finally();
  }, []);
  return <div id={divId} />;
};

export default YtVideo;
